import React from 'react';

function ErrorDisplay({ error }) {
  if (!error) return null;

  return (
    <div className="error-message">
      {error}
    </div>
  );
}

export default ErrorDisplay;
